<script>
    import { onMount } from "svelte";
    import {getFormatter} from "../../utils";

    export let label;
    export let type = 'text';
    export let value;
    export let icon = null;
    export let iconFamily = 'fal';
    export let isDisabled = false;
    export let id = null;
    export let step = '1';

    let fill = false;
    let focus = false;
    let input;

    let currencyMask;
    let formatter;

    onMount(() => {
        setStatus();
        if (type === 'currency') {
            formatter = getFormatter();
            currencyMask = formatter(value);
        }
    });

    function setStatus() {
        fill = value !== '' && value !== undefined;
        focus = false;
    }

    function handleCurrency(ev) {
        const val = ev.target.value;
        value = val.replace(/\D+/g, '');
        currencyMask = formatter(value);
    }

    function numberInput(data, event, plus) {
        if (plus) {
            dispatchAction('data', Math.max(data + plus, 0));
            return;
        }
        if (event === '' || event == null) {
            dispatchAction('data', '');
            return;
        }
        let cast = +event
        if (isNaN(cast)) {
            cast = 0;
        }
        dispatchAction('data', Math.max(cast, 0));
    }
</script>
<div class="naui-field" class:active={fill}>
    <div class="naui-field-back" class:fill={fill}>
        <label class:focus={focus}>{label}</label>
        {#if type === 'email'}
            <input
                    class="naui-input w-100"
                    readonly={isDisabled}
                    type="email"
                    bind:value={value}
                    on:input
                    on:change
                    on:focus={()=> fill=true}
                    on:focusin={()=>focus=false}
            />
        {:else if type === 'password'}
            <input
                    class="naui-input w-100"
                    readonly={isDisabled}
                    type="password"
                    bind:value={value}
                    on:input
                    on:focus={()=> fill=true}
                    on:focusin={()=>focus=false}
            />
        {:else if type === 'number'}
            <input
                    class="naui-input w-100"
                    readonly={isDisabled}
                    type="number"
                    step={step}
                    bind:value={value}
                    on:input
                    on:focus={()=>fill=true}
                    on:focusin={()=>focus=false}
            />
        {:else if type === 'currency'}
            <input
                    class="naui-input w-100"
                    readOnly={isDisabled}
                    type="text"
                    value={currencyMask}
                    bind:this={input}
                    on:input={handleCurrency}
                    on:focus={()=> fill=true}
                    on:focusin={()=>focus=false}
            />
        {:else}
            <input
                    class="naui-input w-100"
                    readOnly={isDisabled}
                    type="text"
                    bind:value={value}
                    bind:this={input}
                    on:input
                    on:focus={()=> fill=true}
                    on:focusin={()=>focus=false}
            />
        {/if}
    </div>
    {#if icon}
        <i class="{iconFamily} fa-{icon} icon"></i>
    {/if}
</div>
<style>
    .naui-field-back.fill {
        background: white;
    }
    .icon{
        position: absolute;
        right:.5rem;
        top:1.3rem;
        font-size: 1.1rem;
        color: var(--secondary);
    }
</style>
